import { CompanyFilter } from './components/filters/company';
import { JobFunctionFilter } from './components/filters/jobFunction';
import { SeniorityFilter } from './components/filters/seniority';
import { LocationsFilter } from './components/filters/locations';
import { RemoteFilter } from './components/filters/remote';
import { SalaryFilter } from './components/filters/salary';
import { EquityFilter } from './components/filters/equity';
import { PostedJobsFilter } from './components/filters/postedJobs';
import { ExpirationFilter } from './components/filters/expiration';
import { SourceFilter } from './components/filters/source';
import { StatusFilter } from './components/filters/status';
import { VisibilityFilter } from './components/filters/visibility';
import { FeaturedFilter } from './components/filters/featured';
import { NumberOfApplicantsFilter } from './components/filters/numberOfApplicants';
import { SourcingCampaignStatusFilter } from './components/filters/sourcingCampaignStatus';

export const createJobsGroups = ({
  jobsFilters,
  sourceOptions,
  statusOptions,
  visibilityOptions,
  seniorityOptions,
  featuredOptions,
  expirationOptions,
  equityOptions,
  hideCompanyFilter,
  isCompanyProfile,
  setFilters,
  isSourcingAgent,
}) => [
  {
    id: 'company',
    title: 'Company',
    show: !hideCompanyFilter,
    filters: [
      {
        id: 'companyId',
        Component: CompanyFilter,
        props: {
          value: jobsFilters.companyId,
          setFilters,
        },
        show: true,
      },
    ],
  },
  {
    id: 'location',
    title: 'Location',
    show: true,
    filters: [
      {
        id: 'locations',
        Component: LocationsFilter,
        props: {
          value: jobsFilters.locations,
          remoteValue: jobsFilters.remote,
          setFilters,
        },
        show: true,
      },
      {
        id: 'remote',
        Component: RemoteFilter,
        props: {
          value: jobsFilters.remote,
          setFilters,
        },
        show: true,
      },
    ],
  },
  {
    id: 'position',
    title: 'Position',
    show: true,
    filters: [
      {
        id: 'jobFunctionId',
        Component: JobFunctionFilter,
        props: {
          value: jobsFilters.jobFunctionId || '',
          setFilters,
        },
        show: true,
      },
      {
        id: 'seniority',
        Component: SeniorityFilter,
        props: {
          value: jobsFilters.seniority || '',
          seniorityOptions,
          setFilters,
        },
        show: true,
      },
    ],
  },
  {
    id: 'compensation',
    title: 'Compensation',
    show: true,
    filters: [
      {
        id: 'salary',
        Component: SalaryFilter,
        props: {
          value: {
            amountMinCents: jobsFilters.compensationAmountMinCents,
            currency: jobsFilters.compensationCurrency,
            period: jobsFilters.compensationPeriod,
          },
          setFilters,
        },
        additionalCountKeys: ['compensationAmountMinCents'],
        show: true,
      },
      {
        id: 'compensationOffersEquity',
        Component: EquityFilter,
        props: {
          value: jobsFilters.compensationOffersEquity || '',
          equityOptions,
          setFilters,
        },
        show: true,
      },
    ],
  },
  {
    id: 'posting-expiration',
    title: 'Posting & expiration',
    show: true,
    filters: [
      {
        id: 'addedAfter',
        Component: PostedJobsFilter,
        props: {
          postedAfter: {
            date: jobsFilters.addedAfter,
            label: 'Added between',
            dateType: 'addedAfter',
            setFilters,
          },
          postedBefore: {
            date: jobsFilters.addedBefore,
            dateType: 'addedBefore',
            setFilters,
          },
        },
        show: true,
      },
      {
        id: 'expirationWithin',
        Component: ExpirationFilter,
        props: {
          value: jobsFilters.expirationWithin || '',
          expirationOptions,
          setFilters,
        },
        show: true,
      },
    ],
  },
  {
    id: 'job-board-display',
    title: 'Job board display',
    show: !isCompanyProfile,
    filters: [
      {
        id: 'featured',
        Component: FeaturedFilter,
        props: {
          value: jobsFilters.featured || '',
          featuredOptions,
          setFilters,
        },
        show: true,
      },
      {
        id: 'visibility',
        Component: VisibilityFilter,
        props: {
          value: jobsFilters.visibility || '',
          visibilityOptions,
          setFilters,
        },
        show: true,
      },
    ],
  },
  {
    id: 'source',
    title: 'Source',
    show: true,
    filters: [
      {
        id: 'source',
        Component: SourceFilter,
        props: {
          value: jobsFilters.source || '',
          sourceOptions,
          setFilters,
        },
        show: true,
      },
    ],
  },
  {
    id: 'status',
    title: 'Status',
    show: true,
    filters: [
      {
        id: 'status',
        Component: StatusFilter,
        props: {
          value: jobsFilters.status || '',
          statusOptions,
          setFilters,
        },
        show: true,
      },
    ],
  },
  {
    id: 'job-board-applicants',
    title: 'Applicants (job board only)',
    show: true,
    filters: [
      {
        id: 'numberOfApplicants',
        Component: NumberOfApplicantsFilter,
        props: {
          value: jobsFilters.numberOfApplicants,
          setFilters,
        },
        show: true,
      },
    ],
  },
  {
    id: 'job-application-boost',
    title: 'Boost Agent Status',
    show: isSourcingAgent,
    filters: [
      {
        id: 'sourcingCampaignStatus',
        Component: SourcingCampaignStatusFilter,
        props: {
          value: jobsFilters.sourcingCampaignStatus,
          setFilters,
          title: 'Any',
        },
        show: isSourcingAgent,
      },
    ],
  },
];
